import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { clickMenuOpen } from "../../../../redux/actions";
import $ from "jquery";

import Autenticador from "../../../../servicios/Autenticador";
import servicioUsuario from "../../../../servicios/servicioUsuario";
import { nombreDeRol } from "../../../../constantes/nombreDeRol";

import logo from "../../../../assets/img/LogoCIC.png";
import logoTexto from "../../../../assets/img/CIC-logo-text.png";
import IconoNuevaFuncionalidad from "../../IconoNuevaFuncionalidad/IconoNuevaFuncionalidad";

class Sidebar extends Component {
  componentDidMount() {
    this.resaltarPaginaActual(this.props.toggled);
  }

  componentDidUpdate() {
    this.resaltarPaginaActual(this.props.toggled);
  }

  resaltarPaginaActual(toggled) {
    $(function () {
      $("#accordionSidebar a").each(function (index, element) {
        if (
          $(element).attr("href").toLowerCase() ===
          window.location.pathname.toLowerCase()
        ) {
          if ($(element).hasClass("collapse-item") === true) {
            $(element).parent().parent().parent().addClass("active");
            !toggled
              ? $(element).parent().parent().addClass("show")
              : $(element).parent().parent().removeClass("show");
            $(element).addClass("active");
          } else {
            $(element).parent().addClass("active");
          }
        }
      });
    });
  }

  render() {
    const { clickMenuOpen, toggled } = this.props;
    return (
      <ul
        className={
          toggled
            ? "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled"
            : "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
        }
        id="accordionSidebar"
      >
        {/* <!-- Sidebar - Brand --> */}
        <NavLink
          className="sidebar-brand d-flex align-items-center justify-content-center bg-white"
          to="/Inicio"
        >
          <img
            className="sidebar-brand-icon"
            src={logo}
            aria-label="Centro de Información Crediticia"
          />
          <img
            className="sidebar-brand-text"
            src={logoTexto}
            aria-label="Centro de Información Crediticia"
          />
        </NavLink>

        {/* <!-- Divider --> */}
        <hr className="sidebar-divider my-0" />
        {/* <!-- Nav Item - Principal --> */}
        <li id="MenuPrincipal" className="nav-item active">
          <NavLink className="nav-link" to="/Inicio">
            <i className="fas fa-fw fa-home"></i>
            <span>Principal</span>
          </NavLink>
        </li>

        {/* <!-- Divider --> */}
        <hr className="sidebar-divider" />

        {/* <!-- Heading --> */}
        <div className="sidebar-heading">Menú</div>

        {servicioUsuario.usaModulo("Padrón") && (
          <>
            {/* <!-- Nav Item - Padrón --> */}
            <li id="MenuPadron" className="nav-item">
              <a
                className="nav-link collapsed"
                href="#top"
                data-toggle="collapse"
                data-target="#collapsePadron"
                aria-expanded="true"
                aria-controls="collapsePadron"
              >
                <i className="fas fa-fw fa-id-card"></i>
                <span>Padrón</span>
              </a>
              <div
                id="collapsePadron"
                className="collapse"
                aria-labelledby="headingPadron"
                data-parent="#accordionSidebar"
              >
                <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">Padrón:</h6>

                  {servicioUsuario.tieneRol(nombreDeRol.PadronConsultar) && (
                    <NavLink
                      className="collapse-item"
                      to="/Padron/ConsultaPadron"
                    >
                      Consultar Padrón
                    </NavLink>
                  )}

                  <h6 className="collapse-header">Solicitudes al Padrón:</h6>
                  {servicioUsuario.tieneRol(
                    nombreDeRol.PadronConsultarSolicitudes
                  ) && (
                      <NavLink
                        className="collapse-item"
                        to={{
                          pathname: "/Padron/ConsultaSolicitudesPadron",
                          state: {
                            ParametrosCargados: null,
                          },
                        }}
                      >
                        Consultar Solicitudes
                      </NavLink>
                    )}

                  {servicioUsuario.tieneRol(
                    nombreDeRol.PadronTramitarSolicitudes
                  ) && (
                      <NavLink
                        className="collapse-item"
                        to="/Padron/InclusionSolicitud"
                      >
                        Solicitar Inclusión
                      </NavLink>
                    )}

                  {servicioUsuario.tieneRol(
                    nombreDeRol.PadronTramitarSolicitudes
                  ) && (
                      <NavLink
                        className="collapse-item"
                        to="/Padron/ModificacionSolicitud"
                      >
                        Solicitar Modificación
                      </NavLink>
                    )}

                  {servicioUsuario.tieneRol(
                    nombreDeRol.PadronTramitarSolicitudes
                  ) && (
                      <NavLink
                        className="collapse-item"
                        to="/Padron/SolicitudPasaporte"
                      >
                        Solicitud Pasaporte
                        <IconoNuevaFuncionalidad funcionalidad="solicitud-pasaporte" fechaLimiteVisible="2025-12-31" diasVisible={7}/>
                      </NavLink>
                    )}
                </div>
              </div>
            </li>
          </>
        )}

        {servicioUsuario.usaModulo("Información Crediticia") && (
          <>
            {/* <!-- Nav Item - informacion crditicia --> */}
            <li id="MenuInformacionCrediticia" className="nav-item">
              <a
                className="nav-link collapsed"
                href="#top"
                data-toggle="collapse"
                data-target="#collapseInformacionCrediticia"
                aria-expanded="true"
                aria-controls="collapseInformacionCrediticia"
              >
                <i className="fas fa-fw fa-file-alt"></i>
                <span>Información Crediticia</span>
              </a>
              <div
                id="collapseInformacionCrediticia"
                className="collapse"
                aria-labelledby="headingInformacionCrediticia"
                data-parent="#accordionSidebar"
              >
                <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">Información Crediticia:</h6>

                  {servicioUsuario.tieneRol(
                    nombreDeRol.InformacionCrediticiaConsultaReporte
                  ) && (
                      <NavLink
                        className="collapse-item"
                        to="/InformacionCrediticia/GenerarReporte"
                      >
                        Generar Reporte
                      </NavLink>
                    )}
                  {servicioUsuario.tieneRol(
                    nombreDeRol.InformacionCrediticiaDescargaArchivos
                  ) && (
                      <NavLink
                        className="collapse-item"
                        to="/InformacionCrediticia/ArchivoDescargable"
                      >
                        Archivo Descargable
                      </NavLink>
                    )}
                </div>
              </div>
            </li>
          </>
        )}

        {servicioUsuario.usaModulo("Autorización") && (
          <>
            {/* <!-- Nav Item - informacion crditicia --> */}
            <li id="MenuAutorizacion" className="nav-item">
              <a
                className="nav-link collapsed"
                href="#top"
                data-toggle="collapse"
                data-target="#collapseAutorizacion"
                aria-expanded="true"
                aria-controls="collapseAutorizacion"
              >
                <i className="fas fa-fw fa-user-check"></i>
                <span>Autorizaciones</span>
              </a>
              <div
                id="collapseAutorizacion"
                className="collapse"
                aria-labelledby="headingAutorizacion"
                data-parent="#accordionSidebar"
              >
                <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">Autorizaciones:</h6>

                  {servicioUsuario.tieneRol(
                    nombreDeRol.AutorizacionConsultar
                  ) && (
                      <NavLink
                        className="collapse-item"
                        to="/Autorizacion/ConsultaAutorizaciones"
                      >
                        Consultar Autorizaciones
                      </NavLink>
                    )}
                  {servicioUsuario.tieneRol(
                    nombreDeRol.AutorizacionConsultar
                  ) && (
                      <NavLink
                        className="collapse-item"
                        to="/Autorizacion/ConsultaEliminadas"
                      >
                        Consultar Eliminadas
                      </NavLink>
                    )}

                  {servicioUsuario.tieneRol(
                    nombreDeRol.AutorizacionTramitar
                  ) && (
                      <NavLink
                        className="collapse-item"
                        to="/Autorizacion/IncluirAutorizacion"
                      >
                        Incluir Autorización
                      </NavLink>
                    )}

                  {servicioUsuario.tieneRol(
                    nombreDeRol.AutorizacionConsultar
                  ) && (
                      <>
                        <h6 className="collapse-header">Revocaciones:</h6>
                        <NavLink
                          className="collapse-item"
                          to="/Autorizacion/ConsultaRevocaciones"
                        >
                          Consultar Revocaciones
                        </NavLink>
                      </>
                    )}
                  <h6 className="collapse-header">Formularios:</h6>
                  <NavLink
                    className="collapse-item"
                    to="/Autorizacion/Formularios"
                  >
                    Descargar Formularios
                  </NavLink>
                </div>
              </div>
            </li>
          </>
        )}

        {servicioUsuario.usaModulo("Cambios CIC") && (
          <>
            {/* <!-- Nav Item - informacion crditicia --> */}
            <li id="MenuCambiosCIC" className="nav-item">
              <a
                className="nav-link collapsed"
                href="#top"
                data-toggle="collapse"
                data-target="#collapseCambiosCIC"
                aria-expanded="true"
                aria-controls="collapseCambiosCIC"
              >
                <i className="fas fa-fw fa-edit"></i>
                <span>Cambios CIC</span>
              </a>
              <div
                id="collapseCambiosCIC"
                className="collapse"
                aria-labelledby="headingCambiosCIC"
                data-parent="#accordionSidebar"
              >
                <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">Cambios CIC:</h6>

                  {servicioUsuario.tieneRol(nombreDeRol.CambiosCicAprobar) ||
                    servicioUsuario.tieneRol(nombreDeRol.CambiosCicSolicitar) ? (
                    <NavLink
                      className="collapse-item"
                      to="/CambiosCIC/SolicitudesDeCambio"
                    >
                      Solicitudes de Cambio
                    </NavLink>
                  ) : null}

                  {servicioUsuario.tieneRol(
                    nombreDeRol.CambiosCicSolicitar
                  ) && (
                      <NavLink
                        className="collapse-item"
                        to="/CambiosCIC/SolicitarModificacion"
                      >
                        Solicitar Modificación
                      </NavLink>
                    )}
                </div>
              </div>
            </li>
          </>
        )}

        {/* <!-- Divider --> */}
        <hr className="sidebar-divider" />

        {/* <!-- Nav Item - Cerrar Sesión --> */}
        <li className="nav-item">
          <button
            className="btn btn-link nav-link"
            onClick={Autenticador.cerrarSesion}
          >
            <i className="fas fa-fw fa-sign-out-alt"></i>
            <span>Cerrar Sesión</span>
          </button>
        </li>

        {/* <!-- Divider --> */}
        <hr className="sidebar-divider d-none d-md-block" />

        {/* <!-- Sidebar Toggler (Sidebar) --> */}
        <div className="text-center d-none d-md-inline">
          <button
            onClick={() => {
              clickMenuOpen();
            }}
            className="rounded-circle border-0"
            id="sidebarToggle"
          ></button>
        </div>
      </ul>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ clickMenuOpen }, dispatch);

const mapStateToProps = (store) => ({
  toggled: store.menuState.menuOpen,
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
